<template>
  <vc-tutorial>
    <div class="vc-tutorial__content">
      <vc-tutorial-carousel class="vc-carousel">
        <li>
          <div class="vc-tutorial__content-header">
            <h2>Por que <span>conciliar</span> suas vendas em cartões?</h2>
          </div>
          <div class="vc-tutorial__content-info">
            <div class="vc-info-box">
              <h2>Controle financeiro</h2>
              <p>
                garante que todas as <b>vendas realizadas com cartões</b> sejam
                efetivamente recebidas
              </p>
              <img alt="Imagem controle financeiro" :src="controleFinanceiro" />
              <p>
                Mantenha seus registros financeiros <b>corretos</b> e
                <b>atualizados</b>
              </p>
            </div>

            <div class="vc-info-box">
              <h2>Evite divergência de valores</h2>
              <p>
                Ajuda a identificar diferenças entre o valor
                <b>informado no PDV</b> e o
                <b>inserido na sua maquininha de cartão</b>
              </p>
              <img
                alt="Imagem evite divergencia de valores"
                :src="divergenciaValores"
              />
              <p>
                Evite surpresas. A <b>saúde financeira</b> do seu negócio é
                vital
              </p>
            </div>
          </div>
        </li>
        <li>
          <div class="vc-tutorial__content-header">
            <h2>
              Mantenha sua conciliação em dia para evitar
              <span>divergências</span> dos valores reais
            </h2>
            <small>
              <b>Após filtrar</b> uma empresa e um mês,
              <b>selecione o período desejado</b> e clique <b>duas vezes</b> no
              dia específico
            </small>
          </div>
          <div class="vc-tutorial__content-info">
            <img alt="Imagem conciliando" :src="conciliando" />
          </div>
        </li>
        <li>
          <div class="vc-tutorial__content-header">
            <h2>
              <span>Concilie</span> os valores pendentes movendo para a coluna
              <span>Movimento de Vendas</span>
            </h2>
            <small>
              <b>Selecione</b> as vendas não conciliadas, arraste o movimento da
              adquirente para o movimente de venda. Caso existam diferenças, é
              preciso informar uma <b>Justificativa</b>
            </small>
          </div>
          <div class="vc-tutorial__content-info">
            <img alt="Imagem conciliado" :src="conciliado" />
          </div>
        </li>
      </vc-tutorial-carousel>
    </div>
  </vc-tutorial>
</template>

<script setup lang="ts">
import controleFinanceiro from "./Images/conciliacaoDeCartoes/controleFinanceiro.svg";
import divergenciaValores from "./Images/conciliacaoDeCartoes/divergenciaValores.svg";
import conciliando from "./Images/conciliacaoDeCartoes/conciliando.gif";
import conciliado from "./Images/conciliacaoDeCartoes/conciliado.gif";
</script>
<style lang="scss">
@import url("./style.scss");
</style>
